import { UserSettingsActions } from '../../ts/actions/UserSettingsActions';
import { ServerService } from '../../ts/services/ServerService';

export class UserActions {

  constructor(private serverService: ServerService,
              private userSettingsActions: UserSettingsActions) {}

  public signout() {
    this.serverService.signOut();
  }

  public changeUserStartPage() {
    this.userSettingsActions.confirmChangeUserStartPage();
  }

  public changeServerDefaultStartPage() {
    this.userSettingsActions.confirmChangeServerDefaultStartPage();
  }

  public changeSiteStartPage() {
    this.userSettingsActions.confirmChangeSiteStartPage();
  }

}
